import React from 'react';
import { Flex, theme, Typography } from 'antd';
import { t } from '../../utils';

const { Text, Paragraph } = Typography;

export const VariableFieldEmptyState = () => {
	const { token } = theme.useToken();
	return (
		<Flex vertical>
			<Paragraph>
				<Text
					style={{ fontSize: token.fontSizeSM, whiteSpace: 'pre-line' }}
					type="danger"
				>
					{t('variables.missingDatasourceIntegration.message')}
				</Text>
				<Text style={{ fontSize: token.fontSizeSM }} strong>
					{t('variables.missingDatasourceIntegration.addIntegrationHeader')}
				</Text>
				<Text style={{ fontSize: token.fontSizeSM }}>
					{' '}
					{t('variables.missingDatasourceIntegration.addIntegrationBody')}
				</Text>
			</Paragraph>
		</Flex>
	);
};
